/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_Plan_RequiredInputs */



/**
* | output |
* | --- |
* | "Your plan doesn't include your own bot. Upgrade first." |
*
* @param {Settings_Own_Bot_Plan_RequiredInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_plan_required = /** @type {((inputs?: Settings_Own_Bot_Plan_RequiredInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_Plan_RequiredInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваш тариф не включает собственного бота. Сначала повысьте тариф.")
	return /** @type {LocalizedString} */ ("Your plan doesn't include your own bot. Upgrade first.")
});